import { Instagram, Music2, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-16 pb-10"
      style={{
        background: "var(--fp-espresso)",
        color: "var(--fp-cream)",
      }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-[1.3fr_1fr_1fr] gap-10 md:gap-6">
          <div>
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center"
                style={{ background: "var(--fp-powder)" }}
              >
                <img
                  src="/assets/floppy-poopy-logo.png"
                  alt="Logo Floppy Poopy"
                  className="w-full h-full object-cover scale-125 translate-y-1"
                />
              </div>
              <span className="font-display text-xl font-bold">
                Floppy Poopy
              </span>
            </div>
            <p
              className="mt-4 text-sm max-w-sm"
              style={{ color: "rgba(255,240,238,0.75)", lineHeight: 1.6 }}
            >
              Le journal de bord intestinal pour toutes les personnes qui
              souhaitent veiller sur leur ventre avec bienveillance
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider opacity-80">
              Liens
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href="#privacy"
                  className="hover:underline underline-offset-4"
                  data-testid="footer-link-privacy"
                >
                  Politique de confidentialité
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider opacity-80">
              Suivre
            </h4>
            <div className="mt-4 flex items-center gap-3">
              {[
                {
                  Icon: Instagram,
                  href: "https://www.instagram.com/floppypoopy.app/",
                  label: "Instagram",
                },
                {
                  Icon: Music2,
                  href: "https://www.tiktok.com/@floppypoopy.app",
                  label: "TikTok",
                },
                { Icon: Mail, href: "mailto:contact@floppypoopy.app", label: "Email" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-transform hover:-translate-y-0.5"
                  style={{
                    background: "rgba(255,240,238,0.08)",
                    border: "1px solid rgba(255,240,238,0.18)",
                    color: "var(--fp-cream)",
                  }}
                >
                  <Icon size={17} strokeWidth={2} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div
          className="mt-12 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs"
          style={{
            borderTop: "1px solid rgba(255,240,238,0.15)",
            color: "rgba(255,240,238,0.6)",
          }}
        >
          <p data-testid="footer-copyright">
            © {year} Floppy Poopy. Tous droits réservés.
          </p>
          <p className="italic">
            Fait avec 🧡 pour tous les ventres compliqués.
          </p>
        </div>
      </div>
    </footer>
  );
}
